import { create } from 'zustand';
import { User } from 'firebase/auth';
import { useCases } from '../../infrastructure/di/container';

interface AdvertChannelsState {
  byAdvert: Record<string, string[]>; // advertUUID -> channelUUIDs
  loading: boolean;
  error?: string;
  load: (user: User | undefined, advertUUID: string) => Promise<void>;
  set: (user: User | undefined, advertUUID: string, channelUUIDs: string[]) => Promise<void>;
  clear: (advertUUID: string) => void;
}

export const useAdvertChannelsStore = create<AdvertChannelsState>((set, get) => ({
  byAdvert: {},
  loading: false,
  async load(user, advertUUID) {
    if (!user) return; set({ loading: true, error: undefined });
    try {
  const uuids = await useCases.getAdvertChannels().execute(advertUUID);
      set({ byAdvert: { ...get().byAdvert, [advertUUID]: uuids }, loading: false });
    } catch (e: any) { set({ loading: false, error: e?.message || 'Failed to load advert channels' }); }
  },
  async set(user, advertUUID, channelUUIDs) {
    if (!user) return; set({ loading: true, error: undefined });
    try {
  await useCases.setAdvertChannels().execute(advertUUID, channelUUIDs);
      set({ byAdvert: { ...get().byAdvert, [advertUUID]: channelUUIDs }, loading: false });
    } catch (e: any) { set({ loading: false, error: e?.message || 'Failed to set advert channels' }); }
  },
  clear(advertUUID) { const map = { ...get().byAdvert }; delete map[advertUUID]; set({ byAdvert: map }); }
}));
